import React, {useEffect, useContext} from 'react'
import { TitleContext, PathContext } from "../../Context";
import { Link } from 'react-router-dom';

export const pageUrl = () => "/php/func_strtoupper";

export default function StrToUpper() {

    const title = useContext(TitleContext);
    const path = useContext(PathContext);
    useEffect(() => {
        title.setPageTitle("PHP strtoupper() Function | A Complete Guide");
        title.setKeyWords("");
        title.setPageDescription("");
        const urls = {
            'previous': '/php/func_strtolower',
            'next': '/php/func_ucfirst'
        }
        path.setPreviousNext(urls);;
    }, [])

    return (
        <section className='mt-5 mb-5'>
            <h3>PHP strtoupper() Function</h3>
            <div className='mt-4 mb-5'>
                <p>
                    The strtoupper() function in PHP is used to convert all alphabetic characters in a string to uppercase. This is useful when you need to standardize the format of strings, such as when displaying titles, headings, or when performing case-insensitive string comparisons where uppercase is required.
                </p>
                <div className='codePalateBox mt-2 mb-4'>
                    <div className='codePalate' dangerouslySetInnerHTML={{
                        __html: `
                            <p><span class="color-red">strtoupper</span>(<span class="color-blue">string</span> <span class="color-pink">$string</span>)</p>
                        `
                    }}></div>
                </div>
                <p>Where,</p>
                <ul style={{ listStyle: 'disc' }}>
                    <li><strong>$string</strong>: The input string that you want to convert to uppercase.</li>
                    <li><strong>Return Value</strong>: It returns a new string where all alphabetic characters have been converted to uppercase.</li>
                </ul>

                <h5 className="mt-5 mb-3">Basic Example of Usage</h5>
                <p>Here is a basic example of using the strtoupper() function:</p>
                <div className='codePalateBox mt-2 mb-4'>
                    <div className='codePalate' dangerouslySetInnerHTML={{
                        __html: `
                        <p>&lt;?php</p>
                        <p class="ml-30">    <span class="color-pink">$text</span> = <span class="color-green">"Hello, world!"</span>;</p>
                        <p class="ml-30">    <span class="color-pink">$uppercaseText</span> = <span class="color-red">strtoupper</span>(<span class="color-pink">$text</span>);</p>
                        <p class="ml-30">    <span class="color-blue">echo</span> <span class="color-pink">$uppercaseText</span>;</p>
                        <p>?&gt;</p>
                        `
                    }}></div>
                </div>
                <p>
                    Output will be the following -
                </p>
                <div className='codePalateBox mt-2 mb-4'>
                    <div className='codePalate' dangerouslySetInnerHTML={{
                        __html: `
                            <p>HELLO, WORLD!</p>
                        `
                    }}></div>
                </div>
                <p>In this example, the string <span className="background-grey">"Hello, world!"</span> is converted to <span className="background-grey">"HELLO, WORLD!"</span>. All lowercase letters in the original string are transformed into their uppercase equivalents.</p>
            </div>
        </section>
    )
}